import CustomModal from '../../../Components/Modal/CustomModal';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';

type WalletConnectModalProps = {
  open: boolean;
  close: () => void;
};

export const WalletConnectModal = ({
  open,
  close,
}: WalletConnectModalProps) => {
  return (
    <CustomModal
      open={open}
      closebtn={'remove'}
      width={{ lg: '50%', md: '50%', sm: '90%', xs: '90%' }}
      modalContent={
        <Grid
          container
          lg={12}
          display={'flex'}
          flexDirection={'column'}
          className="m-0 p-0"
        >
          <p className="p-2 h6 text-left">
            Please ensure if you are using Wallet Connect that your browser and
            wallet are connected to right network - please find a guide
            here:&nbsp;
            <a
              href="https://docs.openzk.net/using-the-openzk-network/guide-to-switching-networks"
              target="_blank"
              style={{
                fontSize: '16px',
                color: '#FFE584',
                textAlign: 'center',
              }}
            >
              Guide to Switching Networks
            </a>
          </p>
          <p className="p-2 h6 text-left">
            Network information for adding a custom network:
          </p>
          <p className="p-2 h6 text-left">Network Name: OpenZK Network</p>
          <p className="p-2 h6 text-left">
            RPC Endpoint: https://rpc.openzk.net
          </p>
          <p className="p-2 h6 text-left">Chain ID: 1345</p>
          <p className="p-2 h6 text-left">Currency Symbol: ozETH</p>
          <p className="p-2 h6 text-left">
            Explorer: https://explorer.openzk.net/
          </p>
          <Grid
            item
            className="px-3 mt-5 mb-2 w-100"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Button
              sx={{
                height: '45px',
                width: '30%',
                backgroundColor: '#000000',
                border: 0.75,
                borderColor: '#FC9D4B',
                borderRadius: '10px',
                color: '#FFE584',
                fontWeight: 'semibold',
                fontFamily: 'PoppinsRegular',
                fontSize: '18px',
                padding: '15px',
                '&:hover': {
                  background:
                    'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                  color: '#ffffff',
                },
                textTransform: 'none',
              }}
              onClick={close}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      }
      setOpen={undefined}
      modalTitle={undefined}
      transparent={undefined}
      height={undefined}
      scrollable={undefined}
    />
  );
};
